import { Project } from '@prisma/client';
import { createContext, useContext, useState } from 'react';

interface ProjectsContextType {
  open: 'create' | 'edit' | 'delete' | null;
  setOpen: (value: 'create' | 'edit' | 'delete' | null) => void;
  currentRow: Project | null;
  setCurrentRow: (row: Project | null) => void;
}

const ProjectsContext = createContext<ProjectsContextType | undefined>(undefined);

export function ProjectsProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState<'create' | 'edit' | 'delete' | null>(null);
  const [currentRow, setCurrentRow] = useState<Project | null>(null);

  return (
    <ProjectsContext.Provider value={{ open, setOpen, currentRow, setCurrentRow }}>
      {children}
    </ProjectsContext.Provider>
  );
}

export function useProjects() {
  const context = useContext(ProjectsContext);
  if (!context) {
    throw new Error('useProjects must be used within ProjectsProvider');
  }
  return context;
}
